/**
 * Session referral tag — captures `?score=X` from a landing URL and attaches
 * the derived band to key PostHog events, so we can see which score bands
 * drive downstream conversions (calculator runs, waitlist joins, book clicks).
 *
 * Tag stored in sessionStorage so it survives navigations within the visit
 * but doesn't persist across sessions.
 */
const KEY = "centennial_referral_score_band_v1";

function bandFor(score) {
  const s = Number(score);
  if (!Number.isFinite(s) || s <= 0) return null;
  if (s >= 41) return "ready_reviewing";
  if (s >= 31) return "building_strongly";
  if (s >= 21) return "time_to_build";
  return "start_today";
}

/** Capture from URL on app boot / route landing. Idempotent within a session. */
export function captureReferralScore() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("score");
    if (!raw) return;
    const band = bandFor(raw);
    if (!band) return;
    if (sessionStorage.getItem(KEY)) return; // first landing wins
    sessionStorage.setItem(KEY, JSON.stringify({ band, score: Number(raw) }));
  } catch {
    /* noop */
  }
}

/** Enrich an event props object with the referral band, if any. */
export function withReferral(props = {}) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return props;
    const { band, score } = JSON.parse(raw);
    return { ...props, referral_score_band: band, referral_score: score };
  } catch {
    return props;
  }
}
